"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var defaultObj = {
  avatar: '',
  comment: '',
  nickname: '',
  pics: [],
  productId: '',
  star: null,
  attrValueId: 0
};
var _attrValue = [{
  image: '',
  price: 0,
  cost: 0,
  otPrice: 0,
  stock: 0
}];
var objTitle = {
  price: {
    title: '售价（元）'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  }
};
var _default = exports.default = {
  name: 'creatComment',
  props: {
    num: {
      type: Number,
      required: 0
    }
  },
  data: function data() {
    var checkProductScore = function checkProductScore(rule, value, callback) {
      if (!value) {
        return callback(new Error('评价星级不能为空'));
      } else {
        callback();
      }
    };
    return {
      ManyAttrValue: [],
      loadingbtn: false,
      loading: false,
      image: '',
      formValidate: {
        avatar: '',
        productId: '',
        comment: '',
        nickname: '',
        pics: [],
        star: null,
        attrValueId: 0
      },
      rules: {
        avatar: [{
          required: true,
          message: '请选择用户头像',
          trigger: 'change'
        }],
        productId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        comment: [{
          required: true,
          message: '请填写评价内容',
          trigger: 'blur'
        }],
        nickname: [{
          required: true,
          message: '请填写用户昵称',
          trigger: 'blur'
        }],
        pics: [{
          required: true,
          message: '请选择评价图片',
          trigger: 'change'
        }],
        star: [{
          required: true,
          validator: checkProductScore,
          trigger: 'change'
        }]
      },
      formThead: Object.assign({}, objTitle),
      manyTabTit: {},
      manyTabDate: {}
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, _attrValue[0]);
      delete obj.image;
      delete obj.brokerage;
      delete obj.brokerageTwo;
      return obj;
    }
  },
  watch: {
    num: {
      handler: function handler(val) {
        this.resetForm('formValidate');
      },
      deep: true
    }
  },
  methods: {
    handleChange: function handleChange() {
      this.$refs.formValidate.clearValidate('star');
    },
    changeGood: function changeGood() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.image = row.image;
        _this.formValidate.productId = row.id;
        _this.getInfo(row.id);
        _this.$refs.formValidate.clearValidate('productId');
      });
    },
    changeType: function changeType(row, index) {
      row.checked = true;
      this.formValidate.attrValueId = row.id;
    },
    // 详情
    getInfo: function getInfo(id) {
      var _this2 = this;
      (0, _product.productDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info, tmp, tmpTab;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                info = res;
                info.attrValueList.forEach(function (val) {
                  val.attrValue = JSON.parse(val.attrValue);
                });
                tmp = {};
                tmpTab = {};
                info.attrList.forEach(function (o, i) {
                  tmp[o.attributeName] = {
                    title: o.attributeName
                  };
                  tmpTab[o.attributeName] = '';
                });
                // 此处手动实现后台原本value0 value1的逻辑
                info.attrValueList.forEach(function (item) {
                  for (var attrValueKey in item.attrValue) {
                    item[attrValueKey] = item.attrValue[attrValueKey];
                  }
                });
                _this2.manyTabTit = tmp;
                _this2.manyTabDate = tmpTab;
                _this2.ManyAttrValue = info.attrValueList;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit) {
      var _this = this;
      _this.$modalUpload(function (img) {
        if (img) {
          !tit ? _this.formValidate.avatar = img[0].sattDir : img.map(function (item) {
            _this.formValidate.pics.push(item.sattDir);
          });
          _this.$refs.formValidate.clearValidate('avatar'); //
        }
      }, tit, 'store');
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.pics.splice(i, 1);
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this3.formValidate.attrValueId === 0) return _this3.$message.warning('请选择商品属性');
          _this3.loadingbtn = true;
          (0, _product.replyCreatApi)(_this3.formValidate).then(function () {
            _this3.$message.success('新增成功');
            _this3.$emit('getList');
            _this3.loadingbtn = false;
          }).catch(function () {
            _this3.loadingbtn = false;
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this.formValidate.pics = [];
      this.formValidate.avatar = '';
      this.ManyAttrValue = [];
      this.$refs[formName].resetFields();
    },
    info: function info() {
      var _this4 = this;
      this.loading = true;
      (0, _product.replyInfoApi)(this.formValidate).then(function () {
        _this4.formValidate = res;
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(this.formValidate.pics);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.formValidate.pics = newItems;
    }
  }
};